import { render, staticRenderFns } from "./FlyersList.vue?vue&type=template&id=02796794&scoped=true&"
import script from "./FlyersList.vue?vue&type=script&lang=js&"
export * from "./FlyersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02796794",
  null
  
)

export default component.exports